/* eslint-disable no-undef */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import React, { useEffect } from 'react';
// changing this to hash router will fix issue with firebase hosting when reloading nested routes
import {
  BrowserRouter as Router, Switch, Route, useLocation,
} from 'react-router-dom';
import ReactGA from 'react-ga4';

import MainNavbar from './components/custom/MainNavbar';
import MainFooter from './components/custom/MainFooter';

import Home from './pages/Home';
import AboutMe from './pages/AboutMe';
import FAQ from './pages/FAQ';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Resources from './pages/Resources';
import Blog from './pages/Blog';
import { getBlogRoutes } from './config/blogs';

const TRACKING_ID = 'G-1ZSFBDYVB8'; // YOUR_OWN_TRACKING_ID
ReactGA.initialize(TRACKING_ID);

function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    ReactGA.send({ hitType: 'pageview', page: pathname + search });
  }, [pathname, search]);

  return null;
}

function Title() {
  const location = useLocation();
  useEffect(() => {
    // Update the document title based on the current route
    switch (location.pathname) {
      case '/':
        document.title = 'Home - CV Therapy';
        break;
      case '/about-me':
        document.title = 'About Us - CV Therapy';
        break;
      case '/services':
        document.title = 'Our Services - CV Therapy';
        break;
      case '/contact-me':
        document.title = 'Contact Us - CV Therapy';
        break;
      case '/resources':
        document.title = 'Resources - CV Therapy';
        break;
      case '/blog':
        document.title = 'Blog - CV Therapy';
        break;
      case '/faq':
        document.title = 'FAQ - CV Therapy';
        break;
      // Add more cases for other routes
      default:
        document.title = 'CV Therapy';
    }
  }, [location]);

  return null;
}

function Routes() {
  return (
    <Router>
      <ScrollToTop />
      <Title />
      <MainNavbar />
      <Switch>
        <Route path="/about-me">
          <AboutMe />
        </Route>
        <Route path="/services">
          <Services />
        </Route>
        <Route path="/faq">
          <FAQ />
        </Route>
        <Route path="/contact-me">
          <Contact />
        </Route>
        <Route path="/resources">
          <Resources />
        </Route>
        <Route path="/blog">
          <Switch>
            {getBlogRoutes().map((route) => (
              <Route exact key={route.path} path={route.path}>
                <route.component key={route.path} />
              </Route>
            ))}
            <Route exact path="/blog">
              <Blog />
            </Route>
          </Switch>
        </Route>
        <Route path="/">
          <Home />
        </Route>
      </Switch>
      <MainFooter />
    </Router>
  );
}

export default Routes;
